import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.primary};
  .subHeader h1 {
    margin: 0;
    font-size: 1.25rem;
  }
  

  .close-div button {
    border: none;
    background: transparent;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  .summary {
    display: flex;
    gap: 12px;
    align-items: center;
    margin: 12px 0 16px 0;
    h2 {
    color: ${({ theme }) => theme.colors.secondary};
  }
  }
  .summary .icon {
    color: ${({ theme }) => theme.colors.secondary};
  }
  .summary .text h2 {
    margin: 0 0 4px 0;
    font-size: 1.1rem;
  }
  .summary .text p {
    margin: 0;
    color: ${({ theme }) => theme.colors.text_gray};
  }

  ul.features {
    margin: 0 0 20px 18px;
    color: ${({ theme }) => theme.colors.text_gray};
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
`;


